import { Page } from "src/components";
import { Flex, Text } from "src/elements";
import { useTranslation } from "src/i18n";

import { StoreSummaryList } from "./components/StoreSummaryList";

const StoreSummaryPage = () => {
  const { t } = useTranslation("common");

  return (
    <Page>
      <Flex padding="10px 10px 0 10px" align="center">
        <Text variant="h3" testId="page-title">
          {t("sidebar.storeSummary")}
        </Text>
      </Flex>

      <StoreSummaryList />
    </Page>
  );
};

export default StoreSummaryPage;
